import React, { useRef, useState, useEffect } from 'react';
import {
  Container,
  Typography,
  TextField,
  Box,
  Button,
  Paper,
  Alert,
  CircularProgress,
} from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import Logo from '../asssets/images/joyful-logo.webp';
export default function OtpScreen() {
  const [otp, setOtp] = useState(['', '', '', '']);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const inputsRef = useRef([]);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [allowed, setAllowed] = useState(null);
  const orderId = searchParams.get('orderId');

  useEffect(() => {
    if (!orderId) {
      setAllowed(false);
      setError('Order ID not found.');
      return;
    }

    const checkOtp = async () => {
      try {
        const { data } = await axios.get(
          `https://backend-pr-app-928105274191.me-central1.run.app/api/v1/rest/orders/${orderId}/check-otp`
        );

        if (data.status) {
          setAllowed(true);
        } else {
          setAllowed(false);
          setError(data.message || 'This link has expired.');
        }
      } catch (err) {
        setAllowed(false);
        setError(
          err.response?.data?.message ||
            'Something went wrong. Please try again.'
        );
      }
    };

    checkOtp();
  }, [orderId]);

  useEffect(() => {
    if (orderId) {
    }
  }, [orderId]);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      setError('');

      if (value && index < 3) {
        inputsRef.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handleSubmit = async () => {
    const otpValue = otp.join('').trim();
    if (otpValue.length !== 4) {
      setError('Please enter last 4 digits of your phone number.');
      return;
    }

    if (!orderId) {
      setError('Order ID not found.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const params = { otp: otpValue };
      const { data: result } = await axios.post(
        `https://backend-pr-app-928105274191.me-central1.run.app/api/v1/rest/orders/${orderId}/verify-otp`,
        params
      );

      setLoading(false);

      if (result.status) {
        setSuccess(true);

        const deliveryFeeId = result.data?.delivery_fee_id;
        setTimeout(() => {
          navigate(
            `/address?orderId=${orderId}&delivery_fee_id=${deliveryFeeId || ''}`
          );
        }, 1000);
      } else {
        setError(result.message || 'OTP verification failed.');
      }
    } catch (err) {
      setLoading(false);
      setError(
        err.response?.data?.message || 'Something went wrong. Please try again.'
      );
      console.error(err);
    }
  };

  return (
    <Container maxWidth="xs" sx={{ mt: 12 }}>
      <Paper
        elevation={0}
        sx={{
          p: 4,
          borderRadius: 4,
          textAlign: 'center',
          width: '100%',
          boxSizing: 'border-box',
          background: 'linear-gradient(145deg, #ffffff 0%, #f8f9ff 100%)',
          border: '1px solid rgba(128, 0, 32, 0.1)',
          boxShadow: '0 10px 40px rgba(128, 0, 32, 0.08)',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: 4,
            background: 'linear-gradient(90deg, #800020 0%, #ff3366 100%)',
          },
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
          <Box
            sx={{
              width: 200,
              height: 200,
              borderRadius: 5,
              background: 'linear-gradient(135deg, #800020 0%, #ff3366 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',

              overflow: 'hidden',
              border: '3px solid white',
            }}
          >
            <img
              src={Logo}
              alt="Address Icon"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          </Box>
        </Box>

        {allowed && (
          <Typography
            variant="h5"
            fontWeight={600}
            gutterBottom
            sx={{
              background: 'linear-gradient(90deg, #800020 0%, #ff3366 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Order #{orderId}
          </Typography>
        )}
        {allowed && (
          <Typography
            variant="body2"
            color="textSecondary"
            gutterBottom
            sx={{ mb: 3 }}
          >
            Someone has sent you a gift, please enter the last 4 digits of your
            phone number to update your address.
          </Typography>
        )}
        {!allowed && (
          <Typography
            variant="body1"
            gutterBottom
            sx={{
              mb: 3,
              py: 2.5,
              px: 3,
              borderRadius: 3,
              background:
                'linear-gradient(135deg, #800020 0%, #a8323c 50%, #ff3366 100%)',
              fontSize: '1.05rem',
              fontWeight: 800,
              color: '#fff',
              textTransform: 'uppercase',
              textAlign: 'center',
              boxShadow: `
        0 8px 32px rgba(128, 0, 32, 0.25),
        inset 0 1px 0 rgba(255, 255, 255, 0.2),
        inset 0 -1px 0 rgba(0, 0, 0, 0.1)
      `,
              letterSpacing: 1,
              transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
              position: 'relative',
              overflow: 'hidden',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '1px',
                background:
                  'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent)',
              },
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 12px 40px rgba(128, 0, 32, 0.35)',
              },
            }}
          >
            {error || 'This link is expired.'}
          </Typography>
        )}
        {allowed && (
          <>
            <Box
              display="flex"
              justifyContent="space-between"
              mt={3}
              mb={3}
              sx={{ gap: 1.5 }}
            >
              {otp.map((digit, index) => (
                <Paper
                  key={index}
                  elevation={digit ? 2 : 0}
                  sx={{
                    flex: 1,
                    borderRadius: 3,
                    overflow: 'hidden',
                    border: `2px solid ${digit ? '#800020' : '#e2e8f0'}`,
                    transition: 'all 0.3s',
                    bgcolor: digit ? 'white' : '#f8f9ff',
                    transform: digit ? 'translateY(-2px)' : 'none',
                    boxShadow: digit
                      ? '0 4px 12px rgba(128, 0, 32, 0.15)'
                      : 'none',
                  }}
                >
                  <TextField
                    inputRef={(el) => (inputsRef.current[index] = el)}
                    value={digit}
                    type="number"
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    inputProps={{
                      maxLength: 1,
                      style: {
                        textAlign: 'center',
                        fontSize: '1.8rem',
                        fontWeight: 700,
                        color: '#2d3748',
                        padding: '12px 0',
                        caretColor: '#800020',
                      },
                    }}
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    sx={{
                      '& .MuiInputBase-root': {
                        height: '100%',
                      },
                    }}
                  />
                </Paper>
              ))}
            </Box>

            <Button
              variant="contained"
              fullWidth
              onClick={handleSubmit}
              disabled={loading || success}
              sx={{
                py: 1.5,
                borderRadius: 3,
                background: 'linear-gradient(90deg, #800020 0%, #ff3366 100%)',
                fontSize: '1rem',
                fontWeight: 600,
                textTransform: 'none',
                boxShadow: '0 6px 20px rgba(128, 0, 32, 0.3)',
                transition: 'all 0.3s',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: '0 12px 25px rgba(128, 0, 32, 0.4)',
                  background:
                    'linear-gradient(90deg, #900028 0%, #ff4777 100%)',
                },
                '&:active': {
                  transform: 'translateY(0)',
                },
                '&.Mui-disabled': {
                  background: '#e2e8f0',
                  color: '#a0aec0',
                  boxShadow: 'none',
                },
              }}
              startIcon={
                loading && <CircularProgress size={20} color="inherit" />
              }
            >
              {loading ? 'Verifying...' : 'Continue'}
            </Button>
          </>
        )}

        {!allowed ||
          (error && (
            <Alert
              severity="error"
              sx={{
                mt: 3,
                borderRadius: 3,
                animation: 'shake 0.5s',
                '@keyframes shake': {
                  '0%, 100%': { transform: 'translateX(0)' },
                  '25%': { transform: 'translateX(-5px)' },
                  '75%': { transform: 'translateX(5px)' },
                },
              }}
            >
              {error}
            </Alert>
          ))}

        {success && (
          <Alert
            severity="success"
            sx={{
              mt: 3,
              borderRadius: 3,
              animation: 'shake 0.5s',
              '@keyframes shake': {
                '0%, 100%': { transform: 'translateX(0)' },
                '25%': { transform: 'translateX(-5px)' },
                '75%': { transform: 'translateX(5px)' },
              },
            }}
          >
            <Typography variant="body2" sx={{ flex: 1, mr: 1 }}>
              OTP Verified Successfully! Redirecting...
            </Typography>
          </Alert>
        )}
      </Paper>
    </Container>
  );
}
